import React from 'react'
import styles from './index.module.css'

interface Props {
    label: string;
    type: 'number' | 'text' | 'password';
    onChangeCallback: (text: string) => void;
    multiline?: boolean
    value?: string;
    disabled?: boolean
    disableLabel?: boolean
    transparent?: boolean
}

export default function RoundedInput(props: Props) {
  const shouldShowFloatingLabel = !props.disableLabel && Boolean(props.value)
  const inputClassName = [
    styles.input,
    shouldShowFloatingLabel ? styles.inputWithLabel : styles.inputWithoutLabel,
    props.multiline ? styles.multilineInput : '',
    props?.transparent && styles.transparent
  ].filter(Boolean).join(' ')

  return (
    <div className={styles.field}>
      {props.multiline ? 
        <textarea
          className={inputClassName}
          placeholder={props.label}
          value={props.value}
          disabled={props.disabled}
          onChange={(e) => props.onChangeCallback(e.target.value)}
        />
      :
      <>
        {!props.disableLabel && <label className={props.value ? styles.label : styles.hiddenLabel}>{props.label}</label>}
        <input disabled={props.disabled} value={props.value} className={inputClassName} placeholder={props.label} type={props.type} onChange={(e) => props.onChangeCallback(e.target.value)}/>
      </>}
    </div>
  )
}
